import React, {lazy, Suspense} from 'react'
import {RoutePropsTypes, VariationsStoreReader} from 'types/types'

import {BottomSheet} from '@vio/atlas/BottomSheet'
import {Loader} from '@vio/atlas/Loader'
import {PopUp} from '@vio/atlas/PopUp'

interface Props extends Omit<RoutePropsTypes, 'meta'> {
  isOpen: boolean
  onClose: () => void
  variationsStoreReader?: VariationsStoreReader
  isMobile: boolean
  updateLocation?: (params: Record<string, unknown>) => void
}

const LazyDebugPanel = lazy(async () => import('./DebugPanel'))

const DebugPanelOverlay = ({
  isOpen,
  onClose,
  protectCode,
  thirdPartyExperiments,
  variationsStoreReader,
  scenarios,
  modulesConfig,
  isMobile,
  updateLocation
}: Props) => {
  const Overlay = isMobile ? BottomSheet : PopUp
  return (
    <Overlay
      isOpen={isOpen}
      width={960}
      navBarProps={{
        centerContent: 'Debug Panel'
      }}
      {...(isMobile ? {onClose} : {closeAction: onClose})}
    >
      <Suspense fallback={<Loader />}>
        <LazyDebugPanel
          protectCode={protectCode}
          thirdPartyExperiments={thirdPartyExperiments}
          variationsStoreReader={variationsStoreReader}
          scenarios={scenarios}
          modulesConfig={modulesConfig}
          updateLocation={updateLocation}
        />
      </Suspense>
    </Overlay>
  )
}

// default export needed due to lazy loading this component
export default DebugPanelOverlay
